import React from "react";
import ReactDOM from "react-dom";
import { EditorBlock } from "draft-js";

export default class TableCell extends React.Component {
  componentDidMount() {
    this.forceUpdate();
  }
  render() {
    let data = this.props.block.getData().toJS();
    const key = data.key;
    const el = document.getElementById(`editor-table-cell-${key}`);
    if (el) {
      return ReactDOM.createPortal(
        <div
          className={`                         
          ${data.align && `editor-block-align-${data.align}`}         
          ${
            data.paddingTop && `editor-block-data-paddingTop-${data.paddingTop}`
          }   
          ${
            data.paddingLeft &&
            `editor-block-data-paddingLeft-${data.paddingLeft}`
          }         
          ${
            data.paddingRight &&
            `editor-block-data-paddingRight-${data.paddingRight}`
          }   
          ${
            data.paddingBottom &&
            `editor-block-data-paddingBottom-${data.paddingBottom}`
          }  
          ${
            data.lineHeight && `editor-block-data-lineHeight-${data.lineHeight}`
          }   
      `}
          onMouseDown={(event) => {
            if (
              this.props.blockProps &&
              this.props.blockProps.onTableCellMouseDown
            ) {
              this.props.blockProps.onTableCellMouseDown(event, key);
            }
          }}
          onMouseOver={(event) => {
            if (
              this.props.blockProps &&
              this.props.blockProps.onTableCellMouseEnter
            ) {
              this.props.blockProps.onTableCellMouseEnter(event, key);
            }
          }}
          onContextMenu={(event) => {
            if (
              this.props.blockProps &&
              this.props.blockProps.onTableContextMenu
            ) {
              this.props.blockProps.onTableContextMenu(event, key);
            }
          }}
        >
          <EditorBlock {...this.props} />
        </div>,
        el
      );
    }
    return <></>;
  }
}
